import { WatchfaceDeviceType } from '@/hooks';
import {
  FontIdKey,
  FontWeightKey
} from '@/services/compiler-refactor/xmlConvert/dataSource';

interface FontIdItem {
  label: string;
  value: FontIdKey;
  weights: { label: string; value: FontWeightKey }[];
  format: string;
}

const fontIdList_L61: FontIdItem[] = [
  {
    label: 'MiSans Latin',
    value: 'misanslatin',
    weights: [
      { label: 'Regular', value: 'regular' },
      { label: 'Medium', value: 'medium' },
      { label: 'Demibold', value: 'demibold' },
      { label: 'Semibold', value: 'semibold' }
    ],
    format: 'otf'
  },
  {
    label: 'MiSansW',
    value: 'misansw',
    weights: [
      { label: 'Regular', value: 'regular' },
      { label: 'Medium', value: 'medium' },
      { label: 'Demibold', value: 'demibold' },
      { label: 'Semibold', value: 'semibold' }
    ],
    format: 'otf'
  },
  {
    label: 'Noto Sans',
    value: 'notosans',
    weights: [
      { label: 'Regular', value: 'regular' },
      { label: 'Medium', value: 'medium' },
      { label: 'Bold', value: 'bold' }
    ],
    format: 'ttf'
  }
];

const fontIdList_N60: FontIdItem[] = [
  {
    label: 'MiSans Latin',
    value: 'misanslatin',
    weights: [
      { label: 'Regular', value: 'regular' },
      { label: 'Medium', value: 'medium' },
      { label: 'Demibold', value: 'demibold' },
      { label: 'Semibold', value: 'semibold' }
    ],
    format: 'otf'
  },
  {
    label: 'MiSansW',
    value: 'misansw',
    weights: [
      { label: 'Regular', value: 'regular' },
      { label: 'Medium', value: 'medium' },
      { label: 'Semibold', value: 'semibold' },
      { label: 'Demibold', value: 'demibold' }
    ],
    format: 'otf'
  }
];

const fontIdList_M67: FontIdItem[] = [
  {
    label: 'MiSansW',
    value: 'misansw',
    weights: [
      { label: 'Regular', value: 'regular' },
      { label: 'Medium', value: 'medium' },
      { label: 'Demibold', value: 'demibold' }
    ],
    format: 'otf'
  },
  {
    label: 'Noto Sans',
    value: 'notosans',
    weights: [
      { label: 'Regular', value: 'regular' },
      { label: 'Medium', value: 'medium' }
    ],
    format: 'ttf'
  }
];

const fontIdList_N65: FontIdItem[] = [
  {
    label: 'MiSans Latin',
    value: 'misanslatin',
    weights: [
      { label: 'Regular', value: 'regular' },
      { label: 'Medium', value: 'medium' },
      { label: 'Demibold', value: 'demibold' },
      { label: 'Semibold', value: 'semibold' }
    ],
    format: 'otf'
  },
  {
    label: 'MiSansW',
    value: 'misansw',
    weights: [
      { label: 'Regular', value: 'regular' },
      { label: 'Medium', value: 'medium' },
      { label: 'Demibold', value: 'demibold' },
      { label: 'Semibold', value: 'semibold' }
    ],
    format: 'otf'
  },
  {
    label: 'Noto Sans',
    value: 'notosans',
    weights: [
      { label: 'Regular', value: 'regular' },
      { label: 'Medium', value: 'medium' },
      { label: 'Bold', value: 'bold' }
    ],
    format: 'ttf'
  }
];

const fontIdList_N62: FontIdItem[] = [
  {
    label: 'MiSans',
    value: 'misans',
    weights: [
      { label: 'Regular', value: 'regular' },
      { label: 'Medium', value: 'medium' },
      { label: 'Demibold', value: 'demibold' },
      { label: 'Semibold', value: 'semibold' }
    ],
    format: 'otf'
  },
  {
    label: 'MiSansf',
    value: 'misansf',
    weights: [
      { label: 'Medium', value: 'medium' },
      { label: 'Demibold', value: 'demibold' },
      { label: 'Semibold', value: 'semibold' }
    ],
    format: 'ttf'
  },
  {
    label: 'Noto Sans',
    value: 'notosans',
    weights: [
      { label: 'Regular', value: 'regular' },
      { label: 'Medium', value: 'medium' },
      { label: 'Bold', value: 'bold' }
    ],
    format: 'ttf'
  }
];

const fontIdList_N66: FontIdItem[] = [
  {
    label: 'MiSans',
    value: 'misans',
    weights: [
      { label: 'Regular', value: 'regular' },
      { label: 'Medium', value: 'medium' },
      { label: 'Demibold', value: 'demibold' },
      { label: 'Semibold', value: 'semibold' }
    ],
    format: 'otf'
  },
  {
    label: 'MiSansf',
    value: 'misansf',
    weights: [
      { label: 'Medium', value: 'medium' },
      { label: 'Demibold', value: 'demibold' },
      { label: 'Semibold', value: 'semibold' }
    ],
    format: 'ttf'
  },
  {
    label: 'Noto Sans',
    value: 'notosans',
    weights: [
      { label: 'Regular', value: 'regular' },
      { label: 'Medium', value: 'medium' },
      { label: 'Bold', value: 'bold' }
    ],
    format: 'ttf'
  }
];

export const deviceFontsMap: Partial<
  Record<WatchfaceDeviceType, FontIdItem[]>
> = {
  L61: fontIdList_L61,
  N60: fontIdList_N60,
  M67: fontIdList_M67,
  N65: fontIdList_N65,
  N62: fontIdList_N62,
  O62: fontIdList_N62,
  O62M: fontIdList_N62,
  N62S: fontIdList_N62,
  N66: fontIdList_N66,
  O65: fontIdList_N62,
  O65M: fontIdList_N62,
  O66: fontIdList_N66,
  O61: fontIdList_N62,
  O63: fontIdList_N62,
  Q63: fontIdList_N62,
  Q66: fontIdList_N66,
  P65: fontIdList_N62,
  P62: fontIdList_N62
};
